import React from 'react';

const BranchesTable = ({ branches }) => {
    if (!branches || !branches.length) return null;

    const totals = branches.reduce(
        (acc, item) => ({
            total: acc.total + (item.total || 0),
            withCoords: acc.withCoords + (item.withCoords || 0),
            withoutCoords: acc.withoutCoords + (item.withoutCoords || 0)
        }),
        { total: 0, withCoords: 0, withoutCoords: 0 }
    );

    return (
        <div className="kt-container kt-container--fluid delivery-map-page__branches-container">
            <h5 style={{ marginBottom: 10 }}>Заказы по филиалам</h5>
            <table className="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Филиал</th>
                        <th style={{ textAlign: 'right' }}>Заказов всего</th>
                        <th style={{ textAlign: 'right' }}>С координатами</th>
                        <th style={{ textAlign: 'right' }}>Без координат</th>
                    </tr>
                </thead>
                <tbody>
                    {branches.map((item) => (
                        <tr key={item.point != null ? item.point : 'none'}>
                            <td>{item.name}</td>
                            <td style={{ textAlign: 'right' }}>{item.total}</td>
                            <td style={{ textAlign: 'right' }}>{item.withCoords}</td>
                            <td style={{ textAlign: 'right' }}>{item.withoutCoords}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td>Итого</td>
                        <td style={{ textAlign: 'right' }}>{totals.total}</td>
                        <td style={{ textAlign: 'right' }}>{totals.withCoords}</td>
                        <td style={{ textAlign: 'right' }}>{totals.withoutCoords}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default BranchesTable;
